import { render, staticRenderFns } from "./qualityDetails.vue?vue&type=template&id=2ff7f10a&scoped=true&"
import script from "./qualityDetails.vue?vue&type=script&lang=js&"
export * from "./qualityDetails.vue?vue&type=script&lang=js&"
import style0 from "./qualityDetails.vue?vue&type=style&index=0&id=2ff7f10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff7f10a",
  null
  
)

export default component.exports